import type { RoundType } from "../puzzles/types";
import type { RoundModule, RoundState } from "./types";
import type { Playable } from "../game/derive";
import { pin } from "./pin";
import { next } from "./next";
import { who } from "./who";

/** One module per round type. Each round's state type is private to its module. */
export const ROUNDS = { pin, next, who } as unknown as Record<RoundType, RoundModule<Playable, RoundState>>;
